import type { PublicChatSession, SessionReading } from './session'

/**
 * Firma y lee el token de la sesión pública (ADR-051). Puro respecto al mundo:
 * no lee reloj ni entorno; el instante llega como argumento y el secreto se
 * inyecta en la implementación.
 */
export interface IPublicChatTokenCodec {
  sign(session: PublicChatSession): string
  verify(token: string, now: Date): SessionReading
}

/** Acción con la que el navegador resuelve el reto al abrir el chat público; el servidor exige la misma. */
export const PUBLIC_CHAT_OPEN_ACTION = 'public-chat-open'

/** Petición de verificación del reto anti-bot (Turnstile, ADR-050). */
export interface BotChallengeRequest {
  /** Token del reto que manda el navegador; ausente ⇒ rechazo (DD22). */
  token: string | null
  /** Acción esperada (p. ej. `public-chat-open`). */
  action: string
  /** IP de quien llama, si se conoce. */
  ip: string | null
}

export type BotChallengeVerdict = { passed: true } | { passed: false; reason: string }

/** Verifica en servidor que quien abre el chat es un navegador humano. Fail-closed. */
export interface IBotChallengeVerifier {
  verify(request: BotChallengeRequest): Promise<BotChallengeVerdict>
}
